import React from 'react';
import { ReactComponent as GroundTargetMarker } from '../../graphics/crossmarker.svg';
import { ReactComponent as AirTargetMarker } from '../../graphics/targetmarker.svg';
import { Coordinate, VideoOverlayObject } from '../VideoPlayer/VideoTypes';

type Props = {
  coord: Coordinate,
  color: string,
  inAir: boolean,
  groundCoord?: Coordinate,
  centerViewOnThis?: boolean,
  lifetime?: number,
  scale?: number,
};

const markerProps = {
  stroke: "#000",
  strokeWidth: 1,
  opacity: 1,
};

const airToGroundLineWidth: number = 2;
const groundShadowSize: number = 40;

const BallMarker = (props: Props) => {
  const {
    coord,
    color,
    inAir,
    groundCoord,
    centerViewOnThis,
    lifetime,
    scale,
  } = props;
  
  const lt: number = lifetime ? Math.max(0, Math.min(1, lifetime)) : 1
  markerProps.opacity = lifetime ? 1-lt : 1;
  const growScale: number = lifetime ? 0.5 + lt * 3 : 1;

  const svgMarker = inAir 
    ? <AirTargetMarker {...markerProps} fill={color} />
    : <GroundTargetMarker {...markerProps} fill={color} />

  const overlayObjects: VideoOverlayObject[] = [];

  overlayObjects.push({
    svg: svgMarker,
    width: 32,
    height: (inAir ? 32 : 15) * growScale * (scale || 1),
    center: coord,
    centerViewOnObject: centerViewOnThis,
  });

  if(groundCoord &&
    groundCoord.x > 0 &&
    groundCoord.y > 0 &&
    coord.x > 0 &&
    coord.y > 0
  ) {
    overlayObjects.push({
      svg: (
        <line
          x1={coord.x}
          y1={coord.y}
          x2={groundCoord.x}
          y2={groundCoord.y}
          style={{ stroke: '#fff9', strokeWidth: airToGroundLineWidth }}
        />
      ),
      width: 0,
      height: 0,
      center: coord,
      disableAutoScale: true,
    });
  
    // Draw shadow on ground
    overlayObjects.push({
      svg: <circle cx={groundCoord.x} cy={groundCoord.y} r={6} style={{ fill: '#0069' }} />,
      width: groundShadowSize,
      height: groundShadowSize,
      center: groundCoord,
      disableAutoScale: true,
    });
  }

  return overlayObjects;
}

export default BallMarker;